import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { isUndefined } from '../../functions';
import { TDateFormat } from '../model/date.types';
import { DateUtil } from '../services';

@Pipe({
  name: 'toDate',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class ToDatePipe implements PipeTransform {
  constructor() {}

  transform(value: string | Date, format: TDateFormat = 'DD/MM/YYYY'): string {
    if (isUndefined(value)) {
      return '';
    }

    const formatted = DateUtil.formatDate(value, format);
    return formatted;
  }
}
